// extracted by mini-css-extract-plugin
module.exports = {"locationInput":"_2-EjFN4lZucNgQeVuNYy6V"};